import type ChartLayer from './ChartLayer';
import type ChartPoint from './ChartPoint';

/**
 * Точка, положенная на экран: пиксельные координаты плюс слой и исходная точка.
 */
class ChartDot {
  readonly x: number;

  readonly y: number;

  readonly layer: ChartLayer;

  readonly point: ChartPoint;

  constructor(x: number, y: number, layer: ChartLayer, point: ChartPoint) {
    this.x = x;
    this.y = y;
    this.layer = layer;
    this.point = point;
  }

  /** Точки, которые представляет этот элемент экрана */
  get dots(): ChartDot[] {
    return [this];
  }
}

export default ChartDot;
